import { appendJobsSectionFilterQueryParameters } from '../../utils/jobs-search-query.utils.js';

const ROOT_SELECTOR = '[data-vacancies-async]';
const FILTER_GROUP_SELECTOR = '[data-filter-param]';
const FILTER_BUTTON_SELECTOR = '[data-filter]';

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || '';
}

function selectedFilters(root) {
  const filters = {};
  const jobType = root.getAttribute('data-vacancies-job-type');

  if (jobType) {
    filters.job_type = [jobType];
  }

  root.querySelectorAll(FILTER_GROUP_SELECTOR).forEach((group) => {
    const param = group.getAttribute('data-filter-param');
    const selected = group.querySelector(`${FILTER_BUTTON_SELECTOR}.is-active`);
    const value = selected?.getAttribute('data-filter');

    if (param) {
      filters[param] = value && value !== 'all' ? [value] : [];
    }
  });

  return filters;
}

function updateViewAllLinks(root, filters) {
  const baseUrl = root.getAttribute('data-vacancies-jobs-url');

  if (!baseUrl) {
    return;
  }

  root.querySelectorAll('[data-vacancies-view-all]').forEach((viewAllLink) => {
    const url = new URL(baseUrl, window.location.origin);

    if (viewAllLink.hasAttribute('data-vacancies-view-all-unfiltered')) {
      url.search = '';
    } else {
      appendJobsSectionFilterQueryParameters(url, filters);
    }

    viewAllLink.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
  });
}

function setSelectedButton(group, selectedButton) {
  group.querySelectorAll(FILTER_BUTTON_SELECTOR).forEach((button) => {
    const isSelected = button === selectedButton;

    button.classList.toggle('is-active', isSelected);
    button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
  });
}

function refreshVacancyEnhancements(root) {
  window.refreshVacanciesSwiper?.(root);
  window.initBtnRoll?.();
  window.initDataTilt?.(root);
  window.refreshAos?.();
}

function initVacancyFilters(root) {
  if (root.hasAttribute('data-vacancies-filters-ready')) {
    return;
  }

  const endpoint = root.getAttribute('data-vacancies-url');
  const slides = root.querySelector('[data-vacancies-slides]');
  const emptyMessage = root.querySelector('[data-vacancies-empty]');

  if (!endpoint || !slides) {
    return;
  }

  root.setAttribute('data-vacancies-filters-ready', '');
  let activeRequest = null;

  updateViewAllLinks(root, selectedFilters(root));

  root.addEventListener('click', async (event) => {
    const button = event.target.closest(FILTER_BUTTON_SELECTOR);
    const group = button?.closest(FILTER_GROUP_SELECTOR);

    if (!button || !group || !root.contains(button)) {
      return;
    }

    event.preventDefault();
    setSelectedButton(group, button);

    const filters = selectedFilters(root);
    updateViewAllLinks(root, filters);

    activeRequest?.abort();
    const request = new window.AbortController();
    activeRequest = request;
    root.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken(),
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          context: root.getAttribute('data-vacancies-context'),
          ...filters,
        }),
        signal: request.signal,
      });

      if (!response.ok) {
        throw new Error(`Vacancy filter request failed with ${response.status}.`);
      }

      const result = await response.json();

      if (typeof result.html !== 'string' || !Number.isInteger(result.count)) {
        throw new Error('Vacancy filter response has an invalid shape.');
      }

      window.destroyVacanciesSwiper?.(root);
      slides.innerHTML = result.html;

      if (emptyMessage) {
        emptyMessage.hidden = result.count !== 0;
      }

      refreshVacancyEnhancements(root);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error);
      }
    } finally {
      if (activeRequest === request) {
        activeRequest = null;
        root.setAttribute('aria-busy', 'false');
      }
    }
  });
}

document.querySelectorAll(ROOT_SELECTOR).forEach(initVacancyFilters);
